

































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
// import { required, sameAs, minLength } from 'vuelidate/lib/validators'
import DateUtils from '@/common/js/DateUtils'
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'

import EditBaseSetting from './edit-pddtokenmodel.vue'
import CreateBaseSetting from './AddPddTokenModel.vue'
class ConfigurationSettingRequest extends PageRequest {
    ConfigurationName: string;
    Keyword: string;
    IsAvailable: string;
    IsLoginInvalid: string;
    IsRevival: string;
    Count: number;
}
@Component({
    name: "pddtoken",
    components: { CreateBaseSetting, EditBaseSetting}
})
export default class ConfigurationSettings extends AbpBase {
    pagerequest: ConfigurationSettingRequest = new ConfigurationSettingRequest();
    creationTime: Date[] = [];
    whetherEffectiveList = [{ name: "全部", value: null }, { name: "是", value: true }, { name: "否", value: false }];
    AuthorizeTime: Date[] = [];
    createModalShow: boolean = false;
    editModalShow: boolean = false;

    edit() {
        this.editModalShow = true;
    }
    create() {
        this.createModalShow = true;
    }
    get list() {
        return this.$store.state.pddtoken.list;
    };
    get loading() {
        return this.$store.state.pddtoken.loading;
    }
    pageChange(page: number) {
        this.$store.commit('pddtoken/setCurrentPage', page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit('pddtoken/setPageSize', pagesize);
        this.getpage();
    }
    async ishandle() {
        this.updateStatus();
    }
    async updatesta() {
        await this.$store.dispatch({
            type: 'pddtoken/updatestan',
            data: {}
        })
        this.getpage();

    }

    async updateStatus() {
        var selectionData: any = this.$refs.selection;
        var selection = selectionData.getSelection();
        if (!selection || selection.length == 0) {
            this.$Message.error("选中项不能为空！");
            return;
        }
        //  var statuName = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == statu })[0].name;

        this.$Modal.confirm({
            title: "token标记不可用", content: "确认批量处理数据？", onOk: async () => {
                var ids = [];
                for (var i = 0; i < selection.length; i++) {
                    ids.push(selection[i].id);
                }
                await this.$store.dispatch({
                    type: 'pddtoken/updateStatus',
                    data: { ids: ids }
                });
                this.getpage();

            }
        });
    }

    async getpage() {
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        await this.$store.dispatch({
            type: 'pddtoken/getAll',
            data: this.pagerequest
        })
    }
    async clearcath() {

        await this.$store.dispatch({
            type: 'pddtoken/ClearCache',
            data: {}
        })
           
        
        this.getpage();

    }


    async delete(data: any) {
        await this.$store.dispatch({
            type: 'pddtoken/delete',
            data: { id: data.id }
        })
        this.getpage();
    }
    get pageSize() {
        return this.$store.state.pddtoken.pageSize;
    }
    get totalCount() {
        return this.$store.state.pddtoken.totalCount;
    }
    get currentPage() {
        return this.$store.state.pddtoken.currentPage;
    }
    async details(data: any) {
        this.$store.state.figtenant.id = data.id;
        this.$router.push({ name: 'tanents' });
    }
    columns = [
        {
            type: 'selection',
            width: 55,
            align: 'center',
            fixed: 'left',
        },
        {
            title: this.L('token'),
            width:200,
            key: 'token'
        },
        {
            title: this.L('创建时间'),
            key: 'createTime'
        },
        {
            title: '是否登陆失效',
            key: 'isLoginInvalid',
            
            render: (h: any, params: any) => {
                return h('span', params.row.isLoginInvalid == "true" ? "有效" : "失效");
            }
        },

        {
            title: this.L('最新获取时间'),
            key: 'totalCountDate',
        },
        {
            title: this.L('获取数量数'),
            key: 'count',
        },
         {
            title: this.L('代理IP'),
             key: 'agentIp',
        },{
            title: this.L('代理账号'),
             key: 'agentAccount',
        },{
            title: this.L('代理密码'),
             key: 'agentPassword',
        },
        {
            title: this.L('备注'),
            key: 'note',
        },{
            title: this.L('是否允许复活'),
            key: 'isRevival',
            render: (h: any, params: any) => {
                return h('span', params.row.isRevival == "true" ? "允许" : "拒绝");
            }
        },{
            title: this.L('错误总数'),
            key: 'errorAllCount',
        },{
            title: this.L('错误提示'),
            key: 'lastError',
        },
        {
            title: '是否有效',
            key: 'isAvailable',
            render: (h: any, params: any) => {
                return h('span', params.row.isAvailable == "true" ? "有效" : "无效");
            }
        },
        {
            title: this.L('Actions'),
            key: 'Actions',
            width: 200,
            render: (h: any, params: any) => {
                return h('div', [
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small'
                        },
                        style: {
                            marginRight: '5px'
                        },
                        on: {
                            click: () => {
                                this.$store.commit('pddtoken/edit', params.row);
                                this.edit();
                            }
                        }
                    }, this.L('修改')),
                    
                    h('Button', {
                        props: {
                            type: 'error',
                            size: 'small'
                        },
                        style: {
                            marginRight: '5px'
                        },
                        on: {
                            click: () => {
                                this.delete(params.row);
                            }
                        }
                    }, this.L('删除')),
                ])
            }
        }
    ]
    async created() {
        await this.getpage();
    }
}
